let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7mIf9"), load("jXweD"), load("76n7a"), load("l253H"), load("ffQaD"), load("kvRbA"), load("gp6Ye")]).then(() => parcelRequire('2azQI'));